import React from "react";
import { Button, Popconfirm, Space, Tooltip } from "antd";
import {
    CheckCircleOutlined,
    DeleteOutlined,
    EditOutlined,
    FileTextOutlined,
    SwapOutlined,
    WarningOutlined,
} from "@ant-design/icons";

import { getPricePeriodActionState } from "../services/fuelPriceWorkbenchViewModel";

const stopEvent = (event) => {
    event?.stopPropagation?.();
};

const ACTION_META = {
    viewDetail: {
        label: "详情",
        icon: <FileTextOutlined />,
        tooltip: "查看周期详情",
    },
    compare: {
        label: "比较",
        icon: <SwapOutlined />,
        tooltip: "查看双快照比较",
    },
    editInternal: {
        label: "我方参考",
        icon: <EditOutlined />,
        tooltip: "编辑我方参考快照",
        style: { color: "#1677ff" },
    },
    editSupplier: {
        label: "供应商报价",
        icon: <EditOutlined />,
        tooltip: "录入供应商报价快照",
        style: { color: "#d48806" },
    },
    confirm: {
        label: "确认周期",
        icon: <CheckCircleOutlined />,
        tooltip: "确认整个价格周期",
        style: { color: "#52c41a" },
    },
    dispute: {
        label: "标记争议",
        icon: <WarningOutlined />,
        tooltip: "标记整个价格周期异常",
        style: { color: "#fa8c16" },
    },
    delete: {
        label: "删除周期",
        icon: <DeleteOutlined />,
        tooltip: "删除草稿周期",
        danger: true,
    },
};

const renderButton = (key, variant, props) => {
    const meta = ACTION_META[key];

    if (!meta) {
        return null;
    }

    return (
        <Tooltip key={key} title={meta.tooltip}>
            <Button
                type="link"
                size="small"
                icon={meta.icon}
                danger={meta.danger}
                style={meta.style}
                onClick={props.onClick}
            >
                {variant === "compact" ? null : meta.label}
            </Button>
        </Tooltip>
    );
};

const PricePeriodActions = ({
    period,
    variant = "compact",
    showCompare = true,
    showDelete = true,
    onViewDetail,
    onOpenComparison,
    onOpenOurPrice,
    onOpenSupplierQuote,
    onConfirm,
    onDispute,
    onDelete,
}) => {
    const actionState = getPricePeriodActionState(period);

    return (
        <Space size={variant === "compact" ? 4 : 8} wrap>
            {renderButton("viewDetail", variant, {
                onClick: (event) => {
                    stopEvent(event);
                    onViewDetail(period);
                },
            })}
            {showCompare
                ? renderButton("compare", variant, {
                      onClick: (event) => {
                          stopEvent(event);
                          onOpenComparison(period);
                      },
                  })
                : null}
            {renderButton("editInternal", variant, {
                onClick: (event) => {
                    stopEvent(event);
                    onOpenOurPrice(period);
                },
            })}
            {renderButton("editSupplier", variant, {
                onClick: (event) => {
                    stopEvent(event);
                    onOpenSupplierQuote(period);
                },
            })}
            {actionState.canConfirm ? (
                <Popconfirm
                    title="确认此价格周期？"
                    onConfirm={() => onConfirm(period)}
                    okText="确认"
                    cancelText="取消"
                >
                    {renderButton("confirm", variant, { onClick: stopEvent })}
                </Popconfirm>
            ) : null}
            {actionState.canDispute
                ? renderButton("dispute", variant, {
                      onClick: (event) => {
                          stopEvent(event);
                          onDispute(period);
                      },
                  })
                : null}
            {showDelete && actionState.canDelete ? (
                <Popconfirm
                    title="确定删除此价格周期？"
                    onConfirm={() => onDelete(period)}
                    okText="删除"
                    cancelText="取消"
                >
                    {renderButton("delete", variant, { onClick: stopEvent })}
                </Popconfirm>
            ) : null}
        </Space>
    );
};

export default PricePeriodActions;
